import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { InvoiceChangeDetail } from "types/portfolio";
import { currencyFormatter } from "utils";
import moment from "moment";
import { useRevenueChange } from "../hooks";
import StatusChip from "components/app/StatusChip";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: 0,
    top: theme.spacing(2),
    color: "grey",
  },
  capitalize: {
    textTransform: "capitalize",
  },
  rowHeight: {
    height: 45,
  },
  borderRight: {
    borderRight: "1px solid #ddd",
  },
  bottom: { marginBottom: "20px" },
}));

const StyledTableCell = withStyles({
  head: {
    backgroundColor: "#F8F9FB",
    fontWeight: "normal",
    fontSize: 14,
    padding: "12px 7px 7px 7px",
    color: "#343537",
    borderLeft: "1px solid #ddd",
    borderTop: "1px solid #ddd",
  },
  body: {
    fontWeight: "normal",
    fontSize: 12,
    borderBottom: "none",
    color: "#343537",
    borderLeft: "1px solid #ddd",
  },
})(TableCell);

export interface InvoiceProps {
  type: "invoiceMrr" | "invoiceArr";
  label: string;
  invoiceHandleClose: () => void;
  invoicePopStatus: boolean;
  accountKey: string;
}

const InvoicePop: React.FC<InvoiceProps> = ({
  type,
  label,
  invoiceHandleClose,
  invoicePopStatus,
  accountKey,
}) => {
  const classes = useStyles();
  const { data: invoiceCellData } = useRevenueChange(invoicePopStatus ? accountKey : "");

  return (
    <>
      <Dialog
        open={invoicePopStatus}
        onClose={invoiceHandleClose}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle className={classes.capitalize}>
          {label} Change
          <Button
            className={classes.closeButton}
            onClick={invoiceHandleClose}
          >
            x
          </Button>
        </DialogTitle>
        <DialogContent className={classes.bottom}>
          <div
            className="ag-theme-material"
            style={{
              height: "40vh",
              width: "100%",
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left">Effective Date</StyledTableCell>
                    <StyledTableCell align="left">Previous/Estimated {label} USD</StyledTableCell>
                    <StyledTableCell
                      align="left"
                      className={classes.borderRight}
                    >
                      The Reason for Change
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoiceCellData?.map((item: InvoiceChangeDetail, idx: number) => (
                    <TableRow
                      key={idx}
                      className={classes.rowHeight}
                      style={{
                        borderBottom:
                          idx === invoiceCellData.length - 1 ? "1px solid #ddd" : "none",
                      }}
                    >
                      <StyledTableCell
                        align="left"
                        style={{
                          filter: item.estimated ? "opacity(0.5)" : undefined,
                        }}
                      >
                        {item?.changedDate
                          ? moment(item?.changedDate)
                              .tz("America/Los_Angeles")
                              .format("MMM Do, YYYY(PT)")
                          : ""}
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <span
                          style={{
                            filter: item.estimated ? "opacity(0.5)" : undefined,
                          }}
                        >
                          {currencyFormatter(item?.[type] ?? 0)}
                        </span>
                        {item.estimated ? (
                          <StatusChip
                            type="PENDING"
                            style={{ marginLeft: 4 }}
                          />
                        ) : null}
                      </StyledTableCell>
                      <StyledTableCell
                        align="left"
                        className={classes.borderRight}
                        style={{
                          filter: item.estimated ? "opacity(0.5)" : undefined,
                        }}
                      >
                        {item?.reasonForChange ?? ""}
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InvoicePop;
